/** Age and DateMath: calendar arithmetic against the engine clock. */
import { monthOf, monthsBetween, yearOf, yearsBetween, type Day } from '../core/calendar.ts';

/** Whole years at `date`; the birthday counts from the 1st of the birth month (January if unknown). */
export function ageInYears(birthYear: number, birthMonth: number | null, date: Day): number {
  const beforeBirthday = birthMonth !== null && monthOf(date) < birthMonth;
  return Math.max(0, yearOf(date) - birthYear - (beforeBirthday ? 1 : 0));
}

/** Age at `date` given today's age: birthday tracked by month when known, else whole elapsed years. */
export function projectedAge(currentAge: number, birthMonth: number | null, date: Day, now: Day): number {
  if (birthMonth === null) return currentAge + yearsBetween(now, date);
  const passedNow = monthOf(now) >= birthMonth;
  const passedAtDate = monthOf(date) >= birthMonth;
  const adjustment = passedNow === passedAtDate ? 0 : passedNow ? -1 : 1;
  return currentAge + yearOf(date) - yearOf(now) + adjustment;
}

/** Whole months from `now` to `date`; negative when `date` is past. */
export const monthsUntil = (date: Day, now: Day): number => monthsBetween(now, date);
